
















import { Component, Prop, Vue } from "vue-property-decorator";
import Personal from "./Personal.vue";
import Educations from "./Educations.vue";
import Jobs from "./Jobs.vue";
import Apply from "./Apply.vue";
import Skills from "./Skills.vue";
import Works from "./Works.vue";
import Tools from "./Tools.vue";
import Books from "./Books.vue";
import {
  Job,
  Personal as PersonalInfo,
  Skill,
  SkillLevel,
  Project,
  Education,
  Tool,
  Book
} from "@/types";

@Component({
  components: {
    Personal,
    Educations,
    Jobs,
    Apply,
    Skills,
    Works,
    Tools,
    Books
  }
})
export default class Portfolio extends Vue {
  tools: Array<Tool> = [
    { name: "Ansible" },
    { name: "JIRA", url: "https://www.atlassian.com/software/jira" },
    {
      name: "Confluence",
      url: "https://www.atlassian.com/software/confluence"
    },
    { name: "Rancher", url: "https://rancher.com/" },
    { name: "Rocket Chat", url: "https://rocket.chat/" },
    { name: "Kibana", url: "https://www.elastic.co/kibana" },
    { name: "Prometheus", url: "https://prometheus.io/" },
    { name: "Grafana", url: "https://grafana.com/" },
    { name: "Postman", url: "https://www.postman.com/" },
    { name: "k9s", url: "https://github.com/derailed/k9s" },
    { name: "Goland", url: "https://www.jetbrains.com/go/" },
    { name: "Eclipse", url: "https://www.eclipse.org/" },
    { name: "Android Studio", url: "https://developer.android.com/studio" },
    { name: "GitLab CE", url: "https://gitlab.com/" },
    {
      name: "Adobe Photoshop",
      url: "https://www.adobe.com/products/photoshopfamily.html"
    },
    { name: "Helm", url: "https://helm.sh/" },
    { name: "Docker", url: "https://www.docker.com/" },
    { name: "Git", url: "https://git-scm.com/" },
    { name: "Visual Studio Code", url: "https://code.visualstudio.com/" },
    { name: "AWS Cli", url: "https://aws.amazon.com/" }
  ];
  jobs: Array<Job> = [
    {
      company: "ionesoft Gmbh",
      jobTitle: "Software Developer",
      city: "Bern, Switzerland",
      url: "https://www.ionesoft.ch",
      quote:
        "Mr. Schlatter has outstanding, in-depth specialist knowledge and extensive experience in other specialist areas as well.",
      from: new Date("2014-01-01"),
      to: new Date("2019-12-30")
    },
    {
      company: "Moskito",
      url: "https://www.moskito.ch",
      jobTitle: "Android Developer (Contract job)",
      city: "Bern, Switzerland",
      quote: "Best value for money",
      from: new Date("2018-01-02"),
      to: new Date("2018-07-02")
    }
  ];
  personal: PersonalInfo = {
    name: "Christian Schlatter",
    homebase: "Bern, Switzerland",
    age: 32,
    email: "christian@schlatter.pw",
    summary: `Enthusiastic software engineer with a passion for Golang and Kubernetes. Long-standing experience with Java and Golang development for App and server backend systems.
        Strong skills in DevOps techniques such as continuous integration, continuous deployment and cluster management as well. Native german and intermediate English speaker.
        Good as a team player and also as a lone ranger`,
    github: "https://github.com/Gambler13",
    gitlab: "https://gitlab.com/hexhibit",
    linkedin: "https://www.linkedin.com/in/christian-schlatter-18170a1a2"
  };
  skills: Array<Skill> = [
    {
      name: "Go / Golang",
      yearsOfExperience: 3,
      level: SkillLevel.Expert,
      keywords: ["Backend", "Server", "Cloud", "Kubernetes", "CI/CD"]
    },
    {
      name: "AWS",
      yearsOfExperience: 4,
      level: SkillLevel.Intermediate,
      keywords: ["S3", "IAM", "Lambda", "EC2", "API Gateway", "Cognito", "SES"]
    },
    {
      name: "Kubernetes",
      yearsOfExperience: 3,
      level: SkillLevel.Expert,
      keywords: ["Rancher", "DigitalOcean", "DevOps", "Custom operators"]
    },
    {
      name: "Docker",
      yearsOfExperience: 3,
      level: SkillLevel.Advanced,
      keywords: ["Docker", "Compose", "Build automation"]
    },
    {
      name: "DevOps",
      yearsOfExperience: 2,
      level: SkillLevel.Advanced,
      keywords: ["Kubernetes", "GitOps", "CI/CD"]
    },
    {
      name: "Monitoring",
      yearsOfExperience: 2,
      level: SkillLevel.Intermediate,
      keywords: [
        "Kubernetes",
        "Prometheus",
        "Grafana",
        "Kibana",
        "Elasticsearch"
      ]
    },
    {
      name: "Java",
      yearsOfExperience: 6,
      level: SkillLevel.Advanced,
      keywords: ["Eclipse RCP", "Eclipse", "IntelliJ", "Ant", "Maven", "Gradle"]
    },
    {
      name: "Android",
      yearsOfExperience: 6,
      level: SkillLevel.Advanced,
      keywords: ["Android", "Android Studio", "IntelliJ", "Gradle"]
    }
  ];
  projects: Array<Project> = [
    {
      title: "beook",
      description: `Beook is a practice-proven platform for digital teaching tools from publishers, educational institutions, associations and authors. The beook app is available as a native app for iOS and Android devices and as a desktop app for Windows and macOS. `,
      skills: [
        "Designed and implemented new features for Android and Windows version",
        "Improved and maintained existing Java codebase",
        "Continuous refactoring and code reviews",
        "Release and test management",
        "Demonstrable experience with Android and Eclipse RCP Framework",
        "Coordinated cross-functional design team"
      ],
      company: "ionesoft GmbH",
      url:
        "https://play.google.com/store/apps/details?id=ch.ionesoft.ilp.android.application.beook",
      urlDisplay: "Play Store",
      keywords: ["Android", "Java", "App", "Eclipse RCP", "ORMLite"]
    },
    {
      title: "ioneaccess",
      description: `ioneacces is the backend system for beook App. It is responsible for managing 
    licenses and assets for the whole beook app. It's successfully designed as a scalable microservice architecture for about 15'000 users and beyond.
    Multiple Services in different programming languages and frameworks, each containerized with Docker and finally orchestrated with Kubernetes.`,
      skills: [
        "Leadership and architecture design",
        "Designed and documented REST APIs with OpenAPI / Swagger",
        "Implemented several high-quality microservices written in Go",
        "Management of multi Kubernetes cluster environments",
        "Set up and maintained a CI/CD pipeline based on GitLab, Docker and Kubernetes",
        "Created a cluster and service monitoring through Prometheus and Grafana",
        "Realisation of a scalable and unified logging backend with use of fluentd and Elasticsearch",
        "Provided mentoring services to Junior Developers and DevOps",
        "Prototyped a Kubernetes CSI implementation",
        "Integration of 3rd party systems (REST / Web APIs / protobuf)"
      ],
      company: "ionesoft GmbH",
      keywords: [
        "Golang",
        "Server",
        "Backend",
        "MySQL",
        "PostgreSQL",
        "Cloud",
        "Kubernetes",
        "Elasticsearch",
        "Open API / Swagger"
      ]
    },

    {
      title: "Moskito",
      description: `Moskito Watch is an analog Swiss watch with Smartwatch features, which is primarily designed for cyclists.
    I developed the Android app for Moskito Watch, which allows the user to connect to the watch via the native app.`,
      skills: [
        "Developed an Android app using Java",
        "Built a GPS route tracking function with an interactive map",
        "Utilized Bluetooth LE GATT profiles to implement a service for communication between app and watch",
        "Implemented interfaces for the Weex cross-platform JavaScript UI framework"
      ],
      company: "Moskito Watch AG",
      url: "https://play.google.com/store/apps/details?id=watch.moskito",
      urlDisplay: "Play Store",
      keywords: [
        "Android",
        "App",
        "Cross Plattform",
        "Weex",
        "VueJS",
        "Bluetooth LE",
        "GATT",
        "GPS Tracking"
      ]
    },
    {
      title: "PDF 2 HTML converter",
      description: `Java application for converting PDF documents into HTML. Originally created as a Bachelor thesis at HSLU the program is still used today for a reasonable PDF to beook eBook conversion.`,
      skills: [
        "Developed a converter in Java from scratch",
        "Integrated various Image- and Fontprocessing tools and libraries",
        "Wrote user-friendly documentation",
        "Ran training courses for employees"
      ],
      company: "ionesoft GmbH / HSLU",
      keywords: [
        "PDF",
        "HTML / CSS",
        "Matrix transformations",
        "PostScript",
        "ImageMagick"
      ]
    },
    {
      title: "Agor",
      description:
        "Agar.io server implementation written in Golang. It is a massively multiplayer online action game. Still work in progress.",
      skills: [
        "Implemented a quadtree written in Golang for collision detection",
        "Usage of websocket connection for bidirectional communication",
        "Designed a binary protocol for high performance messaging"
      ],
      company: "Radio Riot",
      url: "https://github.com/Gambler13/agor",
      urlDisplay: "GitHub repository",
      keywords: ["Golang", "Websockets", "Fullstack", "VueJS", "Socket.io"]
    },
    {
      title: "Radio Riot",
      description:
        "Concert calendar for personal use. Simple VueJS frontend and even simpler Golang Backend.",
      skills: [
        "Developed simple VueJS frontend for management",
        "Created Go backend connected to MySQL database"
      ],
      company: "Radio Riot",
      url: "https://www.riot.fm",
      urlDisplay: "Website",
      keywords: ["VueJS", "HTML / CSS", "Golang", "MySQL", "Fullstack"]
    }
  ];
  educations: Array<Education> = [
    {
      facility: "Lucerne University of Applied Sciences and Arts",
      city: "Luzern",
      educationTitle:
        "Bachelor of Science in Computer Science with Specialisation in Software Systems",
      from: new Date("2011"),
      to: new Date("2015")
    },
    {
      facility: "BMS Bern",
      city: "Bern",
      educationTitle: "Berufsmaturität Technische Fachrichtung",
      from: new Date("2011"),
      to: new Date("2012")
    },
    {
      facility: "GIBB",
      city: "Bern",
      educationTitle: "Haustechnikplaner Heizung EFZ",
      from: new Date("2003"),
      to: new Date("2007")
    }
  ];
  books: Array<Book> = [
    {
      title: "The Joy of x",
      subtitle: "A Guided Tour of Math, from One to Infinity",
      author: "Steven Strogatz"
    },
    {
      title: "Designing Data-Intensive Applications",
      subtitle:
        "The Big Ideas Behind Reliable, Scalable, and Maintainable Systems",
      author: "Martin Kleppmann"
    }
  ];
}
